<template>
  <div v-if="shouldShow" class="action-btn-wrapper">
    <div class="action-overlay-wrapper">
      <div class="action-overlay" />
    </div>
    <div class="action-btn">
      <a
        data-testid="video-end-action"
        class="action-link"
        :href="link"
        target="_blank"
        v-on:click="trackEvent()"
      >
        {{ text }}
      </a>
    </div>
  </div>
</template>

<script>
import track from "@/src/tracking";

export default {
  name: "VideoEndAction",
  props: {
    videoEnded: Boolean,
    text: {
      type: String,
      default: gon.free_video_end_action_text,
    },
    link: {
      type: String,
      default: gon.free_video_end_action_link,
    },
    item: Object,
  },
  data() {
    return {};
  },
  watch: {
    shouldShow(value) {
      if (value) {
        track("end_of_video_cta_shown", {
          item: this.item,
        });
      }
    },
  },
  computed: {
    shouldShow() {
      return (
        this.videoEnded &&
        !this.$store?.state?.user?.id &&
        this.item?.relationships?.organization?.meta?.free
      );
    },
  },
  methods: {
    trackEvent: function () {
      track("end_of_video_cta_clicked", {
        itemId: this.item?.id,
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.action-btn-wrapper {
  position: absolute;
  top: 2.4rem;
  left: 2.4rem;
  bottom: 4rem;
  right: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-btn {
  position: absolute;

  .action-link {
    background-color: rgb(63, 148, 253);
    color: #fff;
    margin-top: 0;
    box-shadow: 0 0 0.75rem 0 rgba(0, 0, 0, 0.7);
    text-decoration: none;
    padding: 17px 26px;
  }
}

.action-overlay-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  .action-overlay {
    width: 100%;
    height: 100%;
    background-color: #0004;
  }
}
</style>
